module.exports = __webpack_public_path__ + "098813dc3335c1c5cd8dc8f0af3e828f.png";